import React from 'react'
import { Header, Image, Modal } from 'semantic-ui-react'

const ModalModalExample = ({ open, element, closeModal }) =>
  open && (
    <Modal open={open} closeIcon onClose={() => closeModal('modalProdutos')}>
      <Modal.Header>{element.title}</Modal.Header>
      <Modal.Content image>
        <Image wrapped size="medium" src={element.imageDefault} />
        <Modal.Description>
          <Header>{element.title}</Header>
          <p>{element.description}</p>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  )

export default ModalModalExample
